import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class AvailableModel extends BaseModel {

    constructor() {
        super({ 
                name: "available",
                tableName: 'available',
                label: "Availability ", 
                default_order: { key: 'updated_at', direction: 'desc' } }, 
            {
            stt: {
                name: "stt",
                label: "No.",
                type: "Computed",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                width: 5,
                // display: { list: true, add: false, edit: false }
            },
            id: { 
                name: 'id', 
                type: "Uuid", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            visit: {
                refs: "visit {id departure arrival week_number visit_start visit_end}",
                display: false
            },
            property: {
                refs: "property {id code name}",
                display: false
            },
            owner: {
                refs: "owner {id fullname}",
                display: false
            },
            week: {
                refs: "week{visit_start visit_end}",
                display: false
            },
            update_user: {
                refs: "update_user {id fullname}",
                display: false
            },
            create_user: {
                refs: "create_user {id fullname}",
                display: false
            },
            rent_service_fee_rate: {
                name: 'rent_service_fee_rate',
                type: "Float",
                label: 'Rent service fee rate',
                display: false
            },
            rent_cleaning_fee: {
                name: 'rent_cleaning_fee',
                type: "Float",
                label: 'Rent cleaning fee',
                display: false
            },
            rent_other_fee: {
                name: 'rent_other_fee',
                type: "Float",
                label: 'Rent other fee',
                display: false
            },
            type: {
                name: 'type',
                type: "Selection",
                label: 'Type',
                options: [
                    {
                        value: '3',
                        label: 'Rent'
                    },
                    {
                        value: '2',
                        label: 'Exchange'
                    }
                ],
                filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
                width: 8,
            },
            status: {
                name: 'status',
                type: "Selection",
                // custom: "SelectionText",
                label: 'Status',
                options: [
                    {
                        value: 'ST001',
                        label: 'Request'
                    },
                    {
                        value: 'ST002',
                        label: 'Accepted'
                    },
                    {
                        value: 'ST003',
                        label: 'Cancelled'
                    },
                ],
                filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
                width: 8,
            },
            property_code: {
                name: 'property_code',
                type: "CustomUrl",
                label: 'Property ID',
                filter: {type: 'input', match: 'contains'},
                computed: (data) => {
                    data.property_code = '';
                },
                width: 8,
            },
            // property_name: {
            //     name: 'property_name',
            //     type: "String",
            //     label: 'Property name',
            //     filter: {type: 'input', match: 'contains'},
            //     computed: (data) => {
            //         data.property_name = '';
            //     },
            // },
            property_name: {
                name: 'property_name',
                type: "CustomUrl",
                label: 'Property name',
                custom: 'SelectionText',
               // models: new PropertyModel(),
                filter: {type: 'input', match: 'contains'},
                class:"left",
                computed: (data) => {
                    data.property_name = '';
                },
                width: 8,
            },
            owner_name: {
                name: 'owner_name',
                type: "CustomUrl",
                label: 'Owner',
                filter: {type: 'input', match: 'contains'},
                computed: (data) => {
                    data.owner_name = '';
                },
                width: 8,
            },
            visit_week: {
                name: 'visit_week',
                type: "String",
                label: 'Week',
                filter: { type: 'DateRange', match: 'contains'},
                computed: (data) => {
                    data.visit_week = '';
                },
                width: 8,
            },
            want_to_exchange: {
                name: 'want_to_exchange',
                type: "String",
                label: 'Want to exchange with',
                computed: (data) => {
                    data.want_to_exchange = '';
                },
                width: 15,
            },
            my_property: { 
                name: 'my_property', 
                type: "Selection",
                custom: "SelectionText",
                label: "Only for owner's property",
                options: [
                    {
                        value: true,
                        label: 'Yes'
                    },
                    {
                        value: false,
                        label: 'No'
                    }
                ],
                filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
                width: 8,
            },
            active: { 
                name: 'active', 
                type: "Selection",
                custom: "SelectionText",
                options: [
                    {
                        value: true,
                        label: 'Yes'
                    },
                    {
                        value: false,
                        label: 'No'
                    }
                ],
                label: 'Active',
                filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
                width: 8,
            },
            updated_name : { 
                name: 'updated_name', 
                type: "String",
                label: 'Updated by',
                computed: (data) => {
                    data.updated_name = '';
                },
                width: 8,
            },
            updated_at : { 
                name: 'updated_at', 
                type: "Datetime",
                label: 'Updated date',
                width: 8,
            }
        },)
    }

}
